// frontend/src/components/Login/Login.tsx

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Preencha todos os campos');
      setLoading(false);
      return;
    }

    if (!email.includes('@')) {
      setError('Email inválido');
      setLoading(false);
      return;
    }

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      if (err.response?.status === 404 && err.response?.data?.needsRegistration) {
        navigate('/register', { state: { email } });
      } else if (err.response?.status === 401) {
        setError('Senha incorreta. Verifique e tente novamente.');
      } else if (err.response?.status === 400) {
        setError(err.response?.data?.message || 'Dados inválidos.');
      } else if (!err.response) {
        setError('Não foi possível contatar o servidor. Verifique sua conexão.');
      } else {
        setError(err.response?.data?.message || 'Erro ao fazer login.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>🚀 AutoSAGE</h1>
          <p>Faça login para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">📧 Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">🔑 Senha</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              ❌ {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? '⏳ Entrando...' : '🔐 Entrar'}
          </button>

          <div className="login-divider">
            <span>ou</span>
          </div>

          <div className="login-footer">
            <span>Não tem uma conta?</span>
            <Link to="/register" className="register-link">
              Cadastre-se
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};